import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  bast_id: '',
  bast_date: '',
  jo_id: '',
  bast_penerimaname: '',
  bast_penerimatelp: '',
  bast_isposted: 0,
  bast_header1: '',
  bast_header2: '',
  bast_header3: '',
  bast_header4: '',
  bast_yangmenerima: '',
  bast_yangmenyerahkan: '',
  bast_createdby: '',
  bast_createddate: '',
  bast_modifyby: '',
  bast_modifydate: '',
  rowid: '',
  detilacc: [],
  detilpart: [],
  detilpartsub: [],
  detilgi: [],
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
  detailTab: 0,
  selectedDetail: {
    name: '',
    id: null,
  },
};

const ops07bastSlice = createSlice({
  name: 'ops07bast',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDetailTab: (state, action) => { state.detailTab = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectedDetail: (state, action) => {
      state.selectedDetail = action.payload || initialState.selectedDetail;
    },
    clearFormData: (state) => {
      state.formData = initialFormData;
      state.selectedDetail = initialState.selectedDetail;
      state.detailTab = 0;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
      state.selectedDetail = initialState.selectedDetail;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
      state.detailTab = 0;
      state.selectedDetail = initialState.selectedDetail;
    },
  },
});

export const {
  setActiveTab,
  setDetailTab,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  updateFormData,
  setSelectedDetail,
  clearFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  clearModuleState,
} = ops07bastSlice.actions;

export default ops07bastSlice.reducer;
